import { globalSingleton } from './utils/global-singleton'

/**
 * The Montilla distribution channel — which package installed and booted the
 * SDK in this runtime. Stamped onto Faro's standard `meta.sdk.integrations`
 * (see {@link getSdkMeta}) so the backend can attribute each event to the way
 * a tenant consumes Montilla: CDN bundle, Nuxt module, or the npm lib directly.
 *
 * This MUST be a runtime signal, not a build-time define: the CDN/Nuxt bundles
 * package the pre-built core, so a define baked into core would always read
 * core's own value. The entrypoints (`@montilla/cdn`, `@montilla/nuxt`) call
 * {@link setDistributionChannel} before `montilla.load(...)`.
 */
const DEFAULT_CHANNEL = '@montilla/core'

/**
 * Preso ao `globalThis`, e não num `let` de módulo, porque o canal decide se o
 * `load()` instala auto-tracking sozinho (`api/load.ts`). Com duas cópias do
 * core no bundle, a cópia que o wrapper não configurou lia o default e
 * instalava um SEGUNDO auto-tracking — cada clique virava dois eventos.
 *
 * Ver `utils/global-singleton.ts` para o porquê de duas cópias existirem.
 */
const channel = globalSingleton('channel', () => ({ current: DEFAULT_CHANNEL }))

/**
 * Set the distribution channel for events emitted in this runtime. Called by
 * the CDN/Nuxt entrypoints before `montilla.load(...)`. Idempotent — the last
 * caller wins; the default (`@montilla/core`) stands for direct lib consumers.
 */
export function setDistributionChannel(pkg: string): void {
  channel.current = pkg
}

/** Read the current distribution channel (defaults to `@montilla/core`). */
export function getDistributionChannel(): string {
  return channel.current
}
